import { z } from 'zod';
import type { HttpClient } from '@wix/cli-http-client';
import type { ComponentGenerationResult } from '@wix/gena';
import type { ProjectModel } from '../../../model.js';

type ExtensionGroup = 'Dashboard' | 'Backend' | 'Site';

interface ExtensionGenerate<TData> {
  projectFolder: string;
  appId: string;
  model: ProjectModel;
  data: TData;
  httpClient: HttpClient;
}

export interface ExtensionDef<
  T extends z.ZodTypeAny = z.ZodTypeAny,
  TData = z.infer<T>,
> {
  title: string;
  description?: string;
  group: ExtensionGroup;
  documentation?: string;
  zodSchema:
    | z.ZodTypeAny
    | ((httpClient: HttpClient) => z.ZodTypeAny | Promise<z.ZodTypeAny>);
  enrich?: (data: z.infer<T>) => TData;
  generate: (
    options: ExtensionGenerate<TData>
  ) => Promise<ComponentGenerationResult | void>;
  validate?: (projectFolder: string, data: TData) => Promise<string | null>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AnyExtensionDef = ExtensionDef<any, any>;

export const extensionFieldDefinitionSchema = z.object({
  title: z.string(),
  description: z.string().optional(),
});

export type ExtensionFieldDefinition = z.infer<
  typeof extensionFieldDefinitionSchema
>;

export const extensionTypeSchema = z.object({
  extensionType: z.string(),
});
